import type { CSSProperties } from "react";
import { Box, CssBaseline, Stack, ThemeProvider, Typography } from "@mui/material";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import YuduLogo from "../../../assets/Yudu-logo.png";
import { lightOnlyTheme } from "../../../utils/theme";

const ICON_BADGE_SX = {
  width: 96,
  height: 96,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: "action.selected",
  color: "primary.main",
};

const FULL_SCREEN_ICON_BADGE_SX = { ...ICON_BADGE_SX, mt: 5, mb: 3 };

const ICON_SX = { fontSize: 48 };

const FULL_SCREEN_SX = { bgcolor: "background.paper" };

const LOGO_STYLE: CSSProperties = { maxHeight: 200, maxWidth: "min(300px, 80vw)", width: "auto", height: "auto" };

export function FullMaintenanceScreen() {
  return (
    <ThemeProvider theme={lightOnlyTheme}>
      <CssBaseline />
      <Stack
        component="output"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        px={3}
        textAlign="center"
        sx={FULL_SCREEN_SX}
      >
        <img src={YuduLogo} alt="Yudu" style={LOGO_STYLE} />
        <Box sx={FULL_SCREEN_ICON_BADGE_SX}>
          <ConstructionRoundedIcon sx={ICON_SX} />
        </Box>
        <Typography
          component="h1"
          variant="overline"
          fontWeight={700}
          letterSpacing="0.2em"
          color="primary"
        >
          Scheduled Maintenance
        </Typography>
        <Typography variant="h5" fontWeight={500} mt={2} maxWidth={520} lineHeight={1.5}>
          The LMS is currently offline while we roll out a set of upgrades.
        </Typography>
        <Typography variant="h6" fontWeight={500} mt={2} maxWidth={520} lineHeight={1.5}>
          Will be back online on October 21.
        </Typography>
        <Typography variant="body1" color="text.secondary" mt={3}>
          Thank you!
        </Typography>
      </Stack>
    </ThemeProvider>
  );
}
